const config: WhiteLabelCofig = {
  'login-title': 'Tutor',
  'primary-colour': '#712d93',
  'class-name': 'tutors',
  'forgot-password-url': 'https://www.tutorsdirectory.co.uk/forgot_password',
}

export default config;
